import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';

import Typography from '@src/new-components/Typography';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import Select from '@src/new-components/Select';
import sanitizeHtml from 'sanitize-html';
import { StyledAcceptPolicyPublishVoice } from './index.style';
import Title from './Title';

const AcceptPolicyPublishVoice = ({
  handleSelectRetentionDays,
  retentionDays,
  isLoadingPublishVoice,
  handleCloseDialog,
  isAcceptPolicy,
  setIsAcceptPolicy,
}) => {
  const { t } = useTranslation();

  const retentionDaysOptions = [
    { id: 1, name: `30 ${t('days')}`, value: 30 },
    { id: 2, name: `60 ${t('days')}`, value: 60 },
    { id: 3, name: `90 ${t('days')}`, value: 90 },
    { id: 4, name: `180 ${t('days')}`, value: 180 },
    { id: 5, name: `1 ${t('year')}`, value: 365 },
  ];

  const handleAcceptPolicy = () => {
    setIsAcceptPolicy(!isAcceptPolicy);
  };

  const onSelectRetentionDays = (e) => {
    if (handleSelectRetentionDays) handleSelectRetentionDays(e.target.value);
  };

  return (
    <StyledAcceptPolicyPublishVoice>
      <Title title={t('shareAndEarn')} handleCloseDialog={handleCloseDialog} />
      <Typography
        component="p"
        variant="body-14-regular"
        color={COLOR.descriptionGray}
      >
        {t('publishVoicePolicyDescription')}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography
          component="p"
          variant="body-14-regular"
          color={COLOR.descriptionGray}
        >
          {t('publishVoicePolicyRetentionDays')}
        </Typography>
        <Box className="select-retention-days">
          <Select
            name="retentionDays"
            value={retentionDays}
            disabled={isLoadingPublishVoice}
            onChange={onSelectRetentionDays}
            options={retentionDaysOptions}
            fullWidth
            getOptionLabel={(option) => (
              <Typography
                variant="body-14-regular"
                color={COLOR.descriptionGray}
              >
                {option.name}
              </Typography>
            )}
            getOptionValue={(option) => option.value}
          />
        </Box>
      </Box>
      <FormControlLabel
        sx={{ textAlign: 'left', marginRight: '0px' }}
        control={
          <Checkbox checked={isAcceptPolicy} onChange={handleAcceptPolicy} />
        }
        label={
          <Typography
            variant="body-14-regular"
            component="span"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(t('confirmPublishPolicyDescription'), {
                allowedTags: ['a'],
                allowedAttributes: {
                  a: ['href', 'target', 'rel', 'style'],
                },
              }),
            }}
          />
        }
      />
    </StyledAcceptPolicyPublishVoice>
  );
};

export default AcceptPolicyPublishVoice;
